import React from "react";

export default function HelpSupportIllustration() {
  return (
    <svg
      className="help-support-illustration"
      viewBox="0 0 420 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="218" cy="119" r="105" fill="#EAF3FF" />
      <circle cx="338" cy="45" r="29" fill="#2865B0" />
      <path
        d="M334 38c0-5 4-9 10-9 5 0 9 3 9 8 0 9-10 8-10 16"
        stroke="white"
        strokeWidth="5"
        strokeLinecap="round"
      />
      <circle cx="343" cy="59" r="2.8" fill="white" />

      <rect x="65" y="27" width="73" height="51" rx="8" fill="#D9EAFD" />
      <path d="M78 41h7M78 51h41M78 61h31" stroke="#73A4DA" strokeWidth="4" strokeLinecap="round" />
      <rect x="35" y="88" width="66" height="43" rx="8" fill="#62A0DF" />
      <path d="M49 103h37M49 114h25" stroke="white" strokeWidth="4" strokeLinecap="round" />

      <path d="M323 210c13-38 28-68 55-88-2 34-9 66-30 91" fill="#B7D8F5" />
      <path d="M337 211c9-31 29-51 53-65-8 30-24 55-43 69" fill="#D8EAF9" />
      <path d="M329 211c-3-27-18-50-39-67 2 32 13 55 32 72" fill="#8EC2EC" />

      <path
        d="M188 79c0-27 20-47 47-47s48 21 48 48v24h-95V79Z"
        fill="#173B6D"
      />
      <ellipse cx="237" cy="82" rx="35" ry="39" fill="#F3B38B" />
      <path
        d="M205 68c8-25 27-35 48-29 17 5 28 20 29 39-13-4-24-14-30-28-9 14-26 23-47 25v-7Z"
        fill="#172F57"
      />
      <path d="M224 86c8 7 18 7 27 0" stroke="#A45347" strokeWidth="3" strokeLinecap="round" />
      <circle cx="221" cy="76" r="2" fill="#25354B" />
      <circle cx="253" cy="76" r="2" fill="#25354B" />
      <path
        d="M201 69c-14 3-18 14-17 30M274 68c14 2 18 13 16 30"
        stroke="#2865B0"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <rect x="180" y="92" width="13" height="25" rx="6" fill="#2865B0" />
      <rect x="282" y="92" width="13" height="25" rx="6" fill="#2865B0" />
      <path d="M290 113c-3 14-15 18-29 17" stroke="#2865B0" strokeWidth="4" strokeLinecap="round" />
      <circle cx="258" cy="130" r="5" fill="#2865B0" />

      <path
        d="M175 137c13-18 35-28 62-28 29 0 52 11 65 31l17 78H155l20-81Z"
        fill="#2874C6"
      />
      <path d="M234 113v101M203 126l30 24 33-24" stroke="#165CA8" strokeWidth="3" />
      <path d="M160 218h165" stroke="#16385F" strokeWidth="6" strokeLinecap="round" />

      <path d="M205 178c13-4 25 1 36 13M272 178c-13-4-25 1-36 13" stroke="#F3B38B" strokeWidth="17" strokeLinecap="round" />
      <path d="M209 192h-99l-17-61h99l17 61Z" fill="#173B6D" />
      <circle cx="151" cy="161" r="5" fill="#DCEBFA" />
      <path d="M101 192h145" stroke="#102C4D" strokeWidth="7" strokeLinecap="round" />

      <rect x="142" y="216" width="183" height="37" rx="10" fill="white" stroke="#D7E4F2" />
      <circle cx="166" cy="234" r="12" fill="#EAF3FF" />
      <path d="M159 235a7 7 0 0 1 14 0M159 235v5M173 235v5" stroke="#2865B0" strokeWidth="2.5" strokeLinecap="round" />
      <text x="188" y="232" fill="#17253B" fontSize="12" fontWeight="700" fontFamily="Arial, sans-serif">
        24/7 Support
      </text>
      <text x="188" y="245" fill="#738096" fontSize="9" fontFamily="Arial, sans-serif">
        We are here to help you
      </text>
    </svg>
  );
}
